import { gql, useQuery } from "@apollo/client";

import { RequestedTestConnection as GraphQLRequestedTestConnection } from "types/graphql";
import { RequestedTest } from "components/flexible_testing/test_request_page/requested_test_page/requested_test_form";

export const GET_REQUESTED_TESTS = gql`
  query getRequestedTests($platform: TestEnvironmentPlatform) {
    requestedTests(filters: { application_type: $platform }, first: 10) {
      edges {
        node {
          id
          name
          testCycleCode
        }
      }
    }
  }
`;

type UseRequestedTestsArguments = {
  platform?: RequestedTest["applicationType"];
};

export const useRequestedTests = ({ platform }: UseRequestedTestsArguments) => {
  const { data, loading } = useQuery<{ requestedTests: GraphQLRequestedTestConnection }>(GET_REQUESTED_TESTS, {
    variables: { platform },
    fetchPolicy: "network-only",
  });
  const requestedTests = data?.requestedTests?.edges.map(({ node }) => node) || [];

  return {
    requestedTests,
    loading,
  };
};
